import checkEntityArray from './checkEntityArray';

export default function assignCar(basicEntity: any, carBlob: any) {
    carBlob = checkEntityArray(carBlob);

    if (basicEntity && carBlob) {
        let newEntity = {
            ...basicEntity,
            ...{
                name: carBlob.name,
                description: carBlob.addressLocality,
                model: carBlob.model,
            },
        };

        if (carBlob.brand) {
            newEntity = {
                ...newEntity,
                ...{
                    brand: { ...carBlob.brand },
                },
            };
        }
        return newEntity;
    }
    return null;
}
